// extracted by mini-css-extract-plugin
export default {"display_board":"DisplayBoard_display_board__iiRFP","title":"DisplayBoard_title__A9-DE","numbers":"DisplayBoard_numbers__TFtkr"};